export var HTTPS_CDN = 'https://img3.doubanio.com';
export var FRODO_DOMAIN = 'https://frodo.douban.com';
export var TALION_DOMAIN = 'https://m.douban.com';
export var TALION_FRODO_API = "".concat(TALION_DOMAIN, "/rexxar");
export var ARK_DOMAIN = 'https://read.douban.com';
export var FRODO_SCHEMA = 'douban://douban.com';
export var ACCOUNTS_DOMAIN = 'https://accounts.douban.com/';
export var REXXAR_DOMAIN = 'douban://rexxar-container';
export var REXXAR_WIDGET_DOMAIN = "".concat(REXXAR_DOMAIN, "/widget");
export var REXXAR_WEBVIEW_DOMAIN = "".concat(REXXAR_DOMAIN, "/webview");
//# sourceMappingURL=consts.js.map